import domain from "./DomainService";

/**
 * Gets submissions and assignments of a pod run of a specified date
 * Only for admins
 */

export default function GetCancelledMembers(stripe_end_date) {
  const token = localStorage.getItem("token");
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({ date : stripe_end_date }),
  };

  return fetch(domain() + "get-cancelled-members", options);
}